export default {
  desktop: {
    TicketPreview: () => import('./TicketPreview'),
    ThemeImporter: () => import(/* webpackChunkName: "lutrijabih-themeWrap" */'./ThemeImporter'),
    LiveThemeImporter: () => import(/* webpackChunkName: "lutrijabihlive-themeWrap" */'./LiveThemeImporter'),
  },
  mobile: {
    TicketPreview: () => import('./TicketPreview'),
    ThemeImporter: () => import(/* webpackChunkName: "lutrijabih-themeWrap" */'./ThemeImporter'),
    LiveThemeImporter: () => import(/* webpackChunkName: "lutrijabihlive-themeWrap" */'./LiveThemeImporter'),
  },
};
